[
  {
    "code": "ELECTRONICS",
    "label": {
      "en": "Electronics",
      "es": "Electronica"
    },
    "order": 1,
    "is_active": true,
    "metadata": {
      "icon": "mdi:laptop"
    }
  },
  {
    "code": "CLOTHING",
    "label": {
      "en": "Clothing & Fashion",
      "es": "Ropa y Moda"
    },
    "order": 2,
    "is_active": true,
    "metadata": {
      "icon": "mdi:tshirt-crew"
    }
  },
  {
    "code": "HOME",
    "label": {
      "en": "Home & Garden",
      "es": "Hogar y Jardin"
    },
    "order": 3,
    "is_active": true,
    "metadata": {
      "icon": "mdi:home"
    }
  },
  {
    "code": "FOOD",
    "label": {
      "en": "Food & Beverages",
      "es": "Alimentacion y Bebidas"
    },
    "order": 4,
    "is_active": true,
    "metadata": {
      "icon": "mdi:food"
    }
  },
  {
    "code": "HEALTH",
    "label": {
      "en": "Health & Beauty",
      "es": "Salud y Belleza"
    },
    "order": 5,
    "is_active": true,
    "metadata": {
      "icon": "mdi:heart-pulse"
    }
  },
  {
    "code": "SPORTS",
    "label": {
      "en": "Sports & Outdoors",
      "es": "Deportes y Aire libre"
    },
    "order": 6,
    "is_active": true,
    "metadata": {
      "icon": "mdi:soccer"
    }
  },
  {
    "code": "AUTOMOTIVE",
    "label": {
      "en": "Automotive",
      "es": "Automocion"
    },
    "order": 7,
    "is_active": true,
    "metadata": {
      "icon": "mdi:car"
    }
  },
  {
    "code": "TOYS",
    "label": {
      "en": "Toys & Games",
      "es": "Juguetes y Juegos"
    },
    "order": 8,
    "is_active": true,
    "metadata": {
      "icon": "mdi:gamepad-variant"
    }
  },
  {
    "code": "BOOKS",
    "label": {
      "en": "Books & Media",
      "es": "Libros y Medios"
    },
    "order": 9,
    "is_active": true,
    "metadata": {
      "icon": "mdi:book"
    }
  },
  {
    "code": "OFFICE",
    "label": {
      "en": "Office & Supplies",
      "es": "Oficina y Papeleria"
    },
    "order": 10,
    "is_active": true,
    "metadata": {
      "icon": "mdi:briefcase"
    }
  },
  {
    "code": "PETS",
    "label": {
      "en": "Pets",
      "es": "Mascotas"
    },
    "order": 11,
    "is_active": true,
    "metadata": {
      "icon": "mdi:dog"
    }
  },
  {
    "code": "BABY",
    "label": {
      "en": "Baby & Kids",
      "es": "Bebes y Ninos"
    },
    "order": 12,
    "is_active": true,
    "metadata": {
      "icon": "mdi:baby-carriage"
    }
  },
  {
    "code": "TOOLS",
    "label": {
      "en": "Tools & Hardware",
      "es": "Herramientas y Ferreteria"
    },
    "order": 13,
    "is_active": true,
    "metadata": {
      "icon": "mdi:hammer"
    }
  },
  {
    "code": "SERVICES",
    "label": {
      "en": "Services",
      "es": "Servicios"
    },
    "order": 14,
    "is_active": true,
    "metadata": {
      "icon": "mdi:hand-heart"
    }
  },
  {
    "code": "OTHER",
    "label": {
      "en": "Other",
      "es": "Otros"
    },
    "order": 99,
    "is_active": true,
    "metadata": {
      "icon": "mdi:dots-horizontal"
    }
  }
]
